import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Divider
} from '@mui/material';

const ConfigurationDetailsDialog = ({
  open,
  onClose,
  configuration
}) => {
  if (!configuration) return null;

  const assemblyTypeName = configuration.assemblyType 
    ? (typeof configuration.assemblyType === 'object' 
        ? configuration.assemblyType.name 
        : 'Unknown')
    : 'Unknown';

  const columns = Array.isArray(configuration.columns) ? configuration.columns : [];

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Configuration Details: {assemblyTypeName}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Assembly Type: <strong>{assemblyTypeName}</strong>
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Column Definitions ({columns.length})
          </Typography>
          
          {columns.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              No columns defined for this configuration.
            </Typography>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold' }}>Order</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Label</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Unit</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Required</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {columns
                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                    .map((column, index) => (
                      <TableRow key={index}>
                        <TableCell>{column.order || index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                            {column.name || '-'}
                          </Typography>
                        </TableCell>
                        <TableCell>{column.label || '-'}</TableCell>
                        <TableCell>
                          <Chip 
                            label={column.type || '-'} 
                            size="small" 
                            color="primary" 
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>{column.unit || '-'}</TableCell>
                        <TableCell>
                          {column.required ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="default" variant="outlined" />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigurationDetailsDialog;
